











import Vue from 'vue';
import * as utils from '@/lib/utils';

const DATES_GROUPS = {
    CURRENT_WEEK: 'currentWeek',
    LAST_WEEK: 'lastWeek',
    CURRENT_MONTH: 'currentMonth',
    LAST_MONTH: 'lastMonth',
    CURRENT_QUARTER: 'currentQuarter',
    LAST_QUARTER: 'lastQuarter',
    CURRENT_YEAR: 'currentYear',
    LAST_YEAR: 'lastYear',
    LAST_30_DAYS: 'last30Days',
    CUSTOM: 'custom',
} as any;

export default Vue.extend({
    props: {

    },
    data() {
        return {
            dates: [] as Array<string>,
            datesGroup: '',
            datesGroupsItems: [] as Array<any>,
            openDatePick: false,
        };
    },
    computed: {
        dateRangeText(): string {
            if (this.dates.length === 2) {
                return `${utils.convertDateToAmericanFormat(this.dates[0] as string)} - ${utils.convertDateToAmericanFormat(this.dates[1] as string)}`;
            }
            return `${utils.convertDateToAmericanFormat(this.dates[0] as string)}`;
        },
    },
    methods: {
        createGroupDatesMenuItems() {
            this.datesGroupsItems = [
                { value: 'This Week', key: DATES_GROUPS.CURRENT_WEEK, setDates: () => this.currentWeek() },
                { value: 'Last Week', key: DATES_GROUPS.LAST_WEEK, setDates: () => this.lastWeek() },
                { value: 'Last 30 Days', key: DATES_GROUPS.LAST_30_DAYS, setDates: () => this.last30Days() },
                { value: 'This Month', key: DATES_GROUPS.CURRENT_MONTH, setDates: () => this.currentMonth() },
                { value: 'Last Month', key: DATES_GROUPS.LAST_MONTH, setDates: () => this.lastMonth() },
                { value: 'This Quarter', key: DATES_GROUPS.CURRENT_QUARTER, setDates: () => this.getQuarter(false) },
                { value: 'Last Quarter', key: DATES_GROUPS.LAST_QUARTER, setDates: () => this.getQuarter(true) },
                { value: 'This Year', key: DATES_GROUPS.CURRENT_YEAR, setDates: () => this.currentYear() },
                { value: 'Last Year', key: DATES_GROUPS.LAST_YEAR, setDates: () => this.lastYear() },
                { value: 'Custom', key: DATES_GROUPS.CUSTOM, setDates: () => this.custom() },
                { divider: true },
            ] as Array<any>;

            const dateObj = utils.getMomentObj(utils.today());
            const monthToday = parseInt(dateObj.format('M'));
            if (monthToday <= 2) return;

            // we want all months until beginning of the year
            for (let i = 2; i < monthToday; i++) {
                // find the month by going back i months from today
                const date = utils.decrementDateByMonths(i, utils.today());
                const dateObj = utils.getMomentObj(date);
                const month = dateObj.format('MMM');
                const year = dateObj.format('YYYY');

                // create a new entry in the menu items
                const key = `${year}${month}`;
                const value = `${year} ${month}`;
                this.datesGroupsItems.push({
                    key,
                    value,
                    setDates: () => this.xMonthsAgo(i),
                });
            }
        },
        datesGroupChanged(group: string) {
            this.removeCustomFromDatesGroups();
            const groupItemSelected = this.datesGroupsItems.find((g: any) => g.key === group);
            groupItemSelected.setDates();
        },
        datesChangedByDatePicker() {
            if (this.dates.length === 2 && this.datesGroupsItems[0].key !== DATES_GROUPS.CUSTOM) {
                this.addCustomToDatesGroups();
                this.datesGroup = DATES_GROUPS.CUSTOM;
            }
        },
        addCustomToDatesGroups() {
            this.datesGroupsItems.unshift({ divider: true });
            this.datesGroupsItems.unshift({
                key: DATES_GROUPS.CUSTOM,
                value: 'Custom',
                setDates: () => {},
            });
        },
        removeCustomFromDatesGroups() {
            if (this.datesGroupsItems[0].key === DATES_GROUPS.CUSTOM) {
                this.datesGroupsItems.shift();
                this.datesGroupsItems.shift();
            }
        },
        custom() {
            this.openDatePick = true;
        },
        customClosed() {
            this.openDatePick = false;
        },
        currentWeek() {
            const dates = [];
            dates.push(utils.getThisWeeksWeekDay(1));
            dates.push(utils.getThisWeeksWeekDay(7));
            this.dates = dates;
        },
        lastWeek() {
            const dates = [];
            dates.push(utils.getLastWeeksWeekDay(1));
            dates.push(utils.getLastWeeksWeekDay(7));
            this.dates = dates;
        },
        currentMonth() {
            const dates = [];
            dates.push(utils.getFirstDayOfMonth(utils.today()));
            dates.push(utils.getLastDayOfMonth(utils.today()));
            this.dates = dates;
        },
        lastMonth() {
            const dates = [];
            dates.push(utils.getFirstDayOfMonth(utils.decrementDateByMonths(1, utils.today())));
            dates.push(utils.getLastDayOfMonth(utils.decrementDateByMonths(1, utils.today())));
            this.dates = dates;
        },
        currentYear() {
            const dates = [];
            dates.push(utils.getFirstDayOfYear(utils.today()));
            dates.push(utils.getLastDayOfYear(utils.today()));
            this.dates = dates;
        },
        lastYear() {
            const dates = [];
            dates.push(utils.getFirstDayOfYear(utils.decrementDateByYears(1, utils.today())));
            dates.push(utils.getLastDayOfYear(utils.decrementDateByYears(1, utils.today())));
            this.dates = dates;
        },
        last30Days() {
            const dates = [];
            dates.push(utils.decremenDateByDays(30, utils.today()));
            dates.push(utils.decremenDateByDays(1, utils.today()));
            this.dates = dates;
        },
        xMonthsAgo(x: number) {
            const dates = [];
            dates.push(utils.getFirstDayOfMonth(utils.decrementDateByMonths(x, utils.today())));
            dates.push(utils.getLastDayOfMonth(utils.decrementDateByMonths(x, utils.today())));
            this.dates = dates;
        },
        getQuarter(lastQuarter: boolean) {
            const dates = [];
            const thisMonth = utils.getMonth(utils.today());
            let firstDayOfYear = utils.getFirstDayOfYear(utils.today());

            let quarter = Math.floor((thisMonth / 3));
            if (quarter === 0 && lastQuarter) {
                firstDayOfYear = utils.getFirstDayOfYear(utils.decrementDateByYears(1, utils.today()));
                quarter = 3;
            }
            let startMonth;
            let lastMonth;
            switch (quarter) {
            case 0:
                startMonth = firstDayOfYear;
                lastMonth = utils.getLastDayOfMonth(utils.incrementDateByMonths(2, firstDayOfYear));
                break;
            case 1:
                startMonth = utils.getFirstDayOfMonth(utils.incrementDateByMonths(3, firstDayOfYear));
                lastMonth = utils.getLastDayOfMonth(utils.incrementDateByMonths(5, firstDayOfYear));
                break;
            case 2:
                startMonth = utils.getFirstDayOfMonth(utils.incrementDateByMonths(6, firstDayOfYear));
                lastMonth = utils.getLastDayOfMonth(utils.incrementDateByMonths(8, firstDayOfYear));
                break;
            case 3:
                startMonth = utils.getFirstDayOfMonth(utils.incrementDateByMonths(9, firstDayOfYear));
                lastMonth = utils.getLastDayOfMonth(utils.incrementDateByMonths(11, firstDayOfYear));
                break;
            default:
                startMonth = firstDayOfYear;
                lastMonth = utils.getLastDayOfMonth(utils.incrementDateByMonths(2, firstDayOfYear));
                break;
            }
            dates.push(startMonth);
            dates.push(lastMonth);
            this.dates = dates;
        },
    },
    created() {
        this.createGroupDatesMenuItems();
        this.currentWeek();
        this.datesGroup = DATES_GROUPS.CURRENT_WEEK;
    },
    watch: {
        dates() {
            this.openDatePick = false;
            if (this.dates.length === 2) {
                this.$emit('inputChange', this.dates);
            }
        },
    },

});
